import { createAsyncThunk } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Actions
import { setUserId } from "./authSlice";
// Service
import StorageService from "services/Storage.service";
// Utilities
import fetcher from "utilities/Fetcher";

const _url:string = '/player';

export const registerUser = createAsyncThunk(
  `${Reducers.Auth}/Register user`,
  async (data:any, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const response:Response = await fetcher(`${_url}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if ( !response.ok ) return rejectWithValue({...(await response.json()) as any, status: response.status});

    const { id:userId } = await response.json();

    StorageService.setQwid(userId);

    dispatch(setUserId(userId));

    return fulfillWithValue('User registered');
  }
);

export const logoutUser = createAsyncThunk(
  `${Reducers.Auth}/Logout user`,
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const response = await fetcher(`${_url}/auth/sign-out`);

    if ( !response.ok ) return rejectWithValue((await response.json()) as any);

    StorageService.clearStorage();

    return fulfillWithValue('User is logged out');
  }
)